module.exports = __webpack_public_path__ + "static/media/pay-ahead-activate.1e319cad.svg";